import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { EndPageService, RegistrationService } from '../../../../services';
import { Router } from '@angular/router';
import { UpdateMinorsModal } from '../update-minors-modal';
import { EndStateContext, REGISTRATION_STATE } from '../../../../../../common/lib/endPage';
import { branding } from '../../../common/text';

declare const GAMING: boolean;

@Component({
  selector: 'waitlist-modal',
  styleUrls: ['./waitlist-modal.component.scss'],
  templateUrl: './waitlist-modal.component.pug'
})
export class WaitlistModal {
  public removedFromWaitlist: boolean;
  public respondedToQuestion: boolean;
  public isFull: boolean;
  public registrationId: number;
  public screening: any;
  public registration: any;
  public brand: string = branding[GAMING ? 'gaming' : 'pfm'];

  constructor(private router: Router, private registrationService: RegistrationService, public dialog: BsModalRef, private modalService: BsModalService,
    private endPageService: EndPageService) { }

  ngOnInit() {
    this.isFull = this.screening && this.screening?.waitlistCount > this.screening?.waitlistMax ? true : false;
    if (this.isFull) {
      this.showEndPage({ registrationState: REGISTRATION_STATE.FULL });
    }
  }

  public onKeyUp() {
    this.close();
  }
  public onOKClicked() {
    this.close(true);
  }

  public onYesClicked() {
    this.registrationService.addToWaitlist(this.registrationId).subscribe(
      (registration) => {
         this.respondedToQuestion = true;
        this.showEndPage({ registrationState: REGISTRATION_STATE.WAITING }, this.registrationId);
      },
      (err) => {
        console.log('Add to waitlist err - ', err);
        this.close();
      }
    );
  }

  public onNoClicked() {
    this.close(true);
  }

  public onOkClicked() {
    this.close(true);
  }

  public onRemoveFromWaitlistClicked() {
    this.registrationService.cancel(this.registrationId).subscribe(
      (registration) => {
        this.removedFromWaitlist = true;
      },
      (err) => {
        console.log('Update registration err - ', err);
        this.close(true);
      }
    );
  }
  
  private redirectURL = () => this.router.navigate(['']);

  private close(onOKClicked = false) {
    this.dialog.hide();
    if (onOKClicked) {
      if (this.registration?.updateMinors) {
        this.presentUpdateMinorsModal(this.screening.id);
      } else {
        this.redirectURL();
      }
    }
  }

  private showEndPage(context: EndStateContext, registrationId?: number) {
    this.dialog.hide();
    const showEndPage = () => this.endPageService.show(this.screening, context, registrationId);
    if (this.registration?.updateMinors) {
      this.presentUpdateMinorsModal(this.screening.id, showEndPage);
    } else {
      showEndPage();
    }
  }

  private presentUpdateMinorsModal(screeningId, next: () => void = this.redirectURL) {
    const modal = this.modalService.show(UpdateMinorsModal, {
      initialState: {
        screeningId, registrationId: this.registration.id,
        account: this.registration?.Account
      },
      class: 'update-minors-modal'
    });
    
    // onSubmit is followed by onHide when the modal closes; only continue once
    let continued = false;
    const continueOnce = () => {
      if (!continued) {
        continued = true;
        next();
      }
    };
    modal.content.onSubmit.subscribe(continueOnce);
    modal.onHide.subscribe(continueOnce);
  }

}
